module.exports = __webpack_public_path__ + "img/936.eb4ea11b.png";